// extracted by css-extract-rspack-plugin
export default {"cls1":"Carousel-cls1_UZ4","cls2":"Carousel-cls2_rHD Carousel-cls1_UZ4"};